import type { UserDto } from '@app/contracts';

const ROLE_LABELS: Record<UserDto['role'], string> = {
  member: 'Membre',
  admin: 'Administrateur',
  super_admin: 'Super-administrateur',
};

export function roleLabel(role: UserDto['role']): string {
  return ROLE_LABELS[role];
}
